import React from 'react';

import { VideoBlockData } from 'api/cms';
import { Body, H2 } from 'components/Text';
import { AmpVideo } from 'components/Video';

type Props = {
  data: VideoBlockData;
};

export function AmpVideoBlock({
  data: { headline, subtitle, videoUrl },
}: Props) {
  return (
    <>
      {headline && <H2>{headline}</H2>}

      {subtitle && (
        <Body
          dangerouslySetInnerHTML={{
            __html: subtitle,
          }}
        />
      )}
      <AmpVideo url={videoUrl} />
    </>
  );
}
